export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/70 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-5">
              <i className="ri-fire-line text-base"></i>
              <span className="whitespace-nowrap">今日吃瓜 · 实时八卦</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
              吃瓜官网
              <br className="hidden sm:block" />
              <span className="text-primary-500">全网最新娱乐资讯平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-3">
              51吃瓜官网在线，汇聚全网最新吃瓜资讯。我们全天候追踪娱乐圈最新动态，
            </p>
            <p className="text-lg md:text-xl text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-3">
              第一时间为您呈现今日吃瓜、实时八卦与本周热门瓜。从明星恋情到综艺路透，
            </p>
            <p className="text-lg md:text-xl text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-3">
              从影视动态到音乐新作，新鲜瓜料每日更新，吃瓜爱好者的一站式资讯入口。
            </p>
            <p className="text-base text-foreground-400 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              当前热门追踪：顶流恋情疑云、综艺录制风波、年度盛典红毯 —— 三大热点同步更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">1280+</div>
                <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">每日更新瓜料</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">24h</div>
                <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">全天候追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">100%</div>
                <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">一手真实瓜源</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看实时热搜
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-base hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-article-line"></i>
                浏览精选瓜文
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/5] md:aspect-square max-w-md mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20vibrant%20abstract%20illustration%20of%20entertainment%20gossip%20and%20celebrity%20news%20culture%2C%20warm%20coral%20red%20and%20golden%20amber%20color%20palette%2C%20dramatic%20magazine%20cover%20composition%20with%20abstract%20newspaper%20elements%2C%20social%20media%20notification%20icons%2C%20megaphone%20silhouette%2C%20trending%20arrows%2C%20modern%20flat%20illustration%20style%20with%20texture%2C%20no%20visible%20text%2C%20bold%20dynamic%20layout%2C%20editorial%20quality&width=800&height=1000&seq=gossip-hero-main&orientation=portrait"
                alt="吃瓜官网 - 全网最新娱乐资讯平台主视觉"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-primary-500/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}